import MsTextToSpeechProvider from './msTextToSpeechProvider.js';

async function textToSpeech(text, opts) {
	const provider = (await getTextToSpeechProvider())?.Instance;
	return provider?.textToSpeech && provider.textToSpeech(text, opts);
}

let ttsProviderPromise = null;
async function getTextToSpeechProvider() {
	if (!ttsProviderPromise) {
		ttsProviderPromise = await {
			Instance: new MsTextToSpeechProvider()
		};
	}
	return ttsProviderPromise;
	
}

export default {	
	textToSpeech,
	getTextToSpeechProvider
}

export {
	textToSpeech,
	getTextToSpeechProvider
}